import { Factory } from '../Factory';
import { ForensicImageType } from './SFTPService';

export class StorageService {
  private configService: any;
  private httpService: any;
  private notificationService: any;

  constructor(configService: any, httpService: any, notificationService: any) {
    this.configService = configService;
    this.httpService = httpService;
    this.notificationService = notificationService;
  }

  public GetFtpListing(storage: { hostname: string, port: number, login: string, password: string, baseDir: string }): any {
    const url = `${this.configService.getServerBaseUrl()}/storage/ftp`;

    const params = {
      hostname: storage.hostname,
      port: storage.port,
      login: storage.login,
      password: storage.password,
      baseDir: storage.baseDir
    };

    return this.httpService.$http({
      method: "GET",
      url: url,
      params: params
    }).success(() => {
      //console.log(files);
    }).error(() => {
      this.notificationService.addError({
        title: 'Error fetching from FTP',
        description: "Please check your login credentials",
        timeout: 5000
      });
    });
  }

  public GetSftpListing(storage: { hostname: string, port: number, login: string, password: string, baseDir: string }): any {
    const url = `${this.configService.getServerBaseUrl()}/storage/sftp`;

    const params = {
      hostname: storage.hostname,
      port: storage.port,
      login: storage.login,
      password: storage.password,
      baseDir: storage.baseDir
    };

    return this.httpService.$http({
      method: "GET",
      url: url,
      params: params
    }).success(() => {
      //console.log(files);
    }).error(() => {
      this.notificationService.addError({
        title: 'Error fetching from SFTP',
        description: "Please check your login credentials",
        timeout: 5000
      });
    });
  }

  public GetS3Listing(storage: { bucketName: string, accessKey: string, secretKey: string, baseDir: string }): any {
    const url = `${this.configService.getServerBaseUrl()}/storage/s3`;

    const params = {
      bucketName: storage.bucketName,
      accessKey: storage.accessKey,
      secretKey: storage.secretKey,
      baseDir: storage.baseDir
    };

    return this.httpService.$http({
      method: "GET",
      url: url,
      params: params
    }).success(() => {
      //console.log(files);
    }).error(() => {
      this.notificationService.addError({
        title: 'Error fetching from S3',
        description: "Please check your login credentials",
        timeout: 5000
      });
    });
  }

  public GetS3QumuloListing(storage: { endpoint: string, bucketName: string, accessKey: string, secretKey: string, baseDir: string }): any {
    const url = `${this.configService.getServerBaseUrl()}/storage/s3qumulo`;

    const params = {
      endpoint: storage.endpoint,
      bucketName: storage.bucketName,
      accessKey: storage.accessKey,
      secretKey: storage.secretKey,
      baseDir: storage.baseDir
    };

    return this.httpService.$http({
      method: "GET",
      url: url,
      params: params
    }).success(() => {
      //console.log(files);
    }).error(() => {
      this.notificationService.addError({
        title: 'Error fetching from S3 Qumulo',
        description: "Please check your login credentials",
        timeout: 5000
      });
    });
  }


  public GetDropboxListing(storage: { username: string, password: string, accessToken: string, baseDir: string }): any {
    const url = `${this.configService.getServerBaseUrl()}/storage/dropbox`;

    const params = {
      username: storage.username,
      password: storage.password,
      accessToken: storage.accessToken,
      baseDir: storage.baseDir
    };

    return this.httpService.$http({
      method: "GET",
      url: url,
      params: params
    }).success(() => {
      //console.log(files);
    }).error(() => {
      this.notificationService.addError({
        title: 'Error fetching from Dropbox',
        description: "Please check your login credentials",
        timeout: 5000
      });
    });
  }

  public GetIioQumuloListing(project, baseDir, imageType: ForensicImageType) {
    const url = `${this.configService.getServerBaseUrl()}/project/${project.id}/client-data`;
    const params = {
      baseDir: encodeURI(baseDir),
    };

    return this.httpService.$http({
      method: "GET",
      url,
      params
    });
  }
}

frontendApp.factory("StorageService", ["ConfigService", "HttpService", "NotificationService", Factory.Create(StorageService)]);
